export default {
  'Upload administrator': '上传管理员',
  'Upload user': '上传会员',
  'Storage mode': '存储方式',
  'Physical path': '物理路径',
  'image width': '图片宽度',
  'Picture height': '图片高度',
  'file size': '文件大小',
  'mime type': 'mime类型',
  'SHA1 code': 'sha1',
  'The file is saved in the directory, and the file will not be automatically transferred if the record is modified':
    '文件保存目录，修改记录不会自动转移文件',
  'File saving path Modifying records will not automatically transfer files':
    '文件保存路径，修改记录不会自动转移文件',
  'Width of picture file': '图片文件的宽度',
  'Height of picture file': '图片文件的高度',
  'Original file name': '文件原始名称',
  'File size (bytes)': '文件大小(bytes)',
  'File MIME type': '文件mime类型',
  'Upload (Reference) times of this file': '此文件的上传(引用)次数',
  'When the same file is uploaded multiple times, only one attachment record will be saved and added':
    '同一文件被多次上传时，只会保存一份和增加一条附件记录',
  'SHA1 encoding of file': '文件的sha1编码',
  'Files and records will be deleted at the same time Are you sure?':
    '将同时删除文件和记录，确认吗？'
}
